import clsx from "clsx";

import Button from "~/components/common/button";

import styles from "../../deliveryNew/index.module.scss";

/**
 * Таблица СДЭК. Стоимость/условия — из CONFIG доставки (без захардкоженных
 * цен по городам). Пункты СДЭК на карточке товара не показываем.
 */
export default function Sdek({ delivery, onBuy, canBuy, isShow }: any) {
  if (!isShow) {
    return null;
  }

  return (
    <div className={clsx(styles.TableSmall, styles.Table)}>
      <span className={styles.Head}>Условия доставки</span>
      <span className={styles.Head}>Стоимость</span>
      <span className={styles.HeadLast} />
      <span>Доставка в пункт самовывоза СДЭК</span>
      <span>{delivery?.CONFIG?.PRICE || delivery?.DESCRIPTION}</span>
      <span className={styles.TableButton}>
        {canBuy && (
          <Button label="Оформить покупку" type="outline" onClick={onBuy} />
        )}
      </span>
    </div>
  );
}
